import {CONSTANTS} from "../../constants/constants"
import styles from "./CropFrame.module.css"

interface CropFrameProps {
    onDragStart: (e: React.MouseEvent<HTMLCanvasElement>) => void
    onDrag: (e: React.MouseEvent<HTMLCanvasElement>) => void
    onDragEnd: () => void
    onMouseLeave: () => void
    canvasRef: React.RefObject<HTMLCanvasElement>
    disabled: boolean
    className?: string
}

export const CropFrame = ({
    onDragStart,
    onDrag,
    onDragEnd,
    onMouseLeave,
    canvasRef,
    disabled,
    className,
}: CropFrameProps) => {
    return (
        <canvas
            ref={canvasRef}
            width={CONSTANTS.CONTAINER_SIZE}
            height={CONSTANTS.CONTAINER_SIZE}
            className={`${className} ${styles.canvas}`}
            onMouseDown={disabled ? undefined : onDragStart}
            onMouseMove={disabled ? undefined : onDrag}
            onMouseUp={disabled ? undefined : onDragEnd}
            onMouseLeave={disabled ? undefined : onMouseLeave}
            style={
                disabled
                    ? {
                          cursor: "not-allowed",
                          border: "1px solid var(--line, #e5e7eb)",
                      }
                    : {
                          border: "1px solid var(--line, #e5e7eb)",
                      }
            }
        />
    )
}
